import React, {
  useState,
} from 'react';
import {
  PatientMetaDataProps,
} from 'pages/Dashboard/pages/Encounters/pages/List/types/patientMetaData';
import {
  useGetPastVisitNotesForPatient,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/hooks';
import MediaListSkeleton from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails/MediaListSkeleton';
import PastNoteRow from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails/PastNotes/PastNoteRow';
import PastNotesProvider from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails/PastNotes/PastNotesContext';

export default function PastNotes({ encounter }: PatientMetaDataProps) {
  const {
    patient,
    visitNoteId: currentVisitNoteId = 0,
    isFinalized,
  } = encounter ?? {};
  const patientId = patient?.patientId ?? 0;
  const [expandedVisitNoteId, setExpandedVisitNoteId] = useState<number | null>(null);

  const {
    data: pastNotes = [],
    isLoading,
  } = useGetPastVisitNotesForPatient(patientId, currentVisitNoteId);

  return (
    <PastNotesProvider patientId={patientId} isCurrentNoteFinalized={isFinalized ?? false}>
      {isLoading ? (
        <MediaListSkeleton className="px-4" />
      ) : (
        <div className="flex flex-col flex-1 overflow-y-auto">
          {pastNotes.length > 0 ? (
            pastNotes.map((note) => {
              const visitNoteId = note.visitNoteId ?? 0;
              return (
                <PastNoteRow
                  key={visitNoteId || (note.encounterId ?? 0)}
                  note={note}
                  isExpanded={expandedVisitNoteId === visitNoteId}
                  onToggleExpand={() => {
                    setExpandedVisitNoteId(
                      (prev) => (prev === visitNoteId ? null : visitNoteId),
                    );
                  }}
                />
              );
            })
          ) : (
            <div className="px-4 py-2 text-xs text-gray-500">
              No past visit notes
            </div>
          )}
        </div>
      )}
    </PastNotesProvider>
  );
}
